import { render, staticRenderFns } from "./resumeSubmit.vue?vue&type=template&id=2d56b8df&scoped=true&"
import script from "./resumeSubmit.vue?vue&type=script&lang=js&"
export * from "./resumeSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56b8df",
  null
  
)

export default component.exports